<template>
    <header>
        <div class="topMenu">
            <app-login></app-login>
            <nav id="topMenuBar">
                <ul>
                    <li>
                        <router-link to="/">Accueil</router-link>
                    </li>
                    <!--<li>
                        <router-link to="/events">Ateliers présentiels</router-link>
                    </li>-->
                    <li>
                        <router-link to="/partners">Partenaires</router-link>
                    </li>
                    <li>
                        <router-link to="/about">À propos</router-link>
                    </li>
                    <li>
                        <router-link to="/contact">Contact</router-link>
                    </li>
                </ul>

            </nav>
        </div>
        <div id="mainTitle">
            <router-link to="/">
                <svg width="123" height="150">
                    <polygon points="67,0 122,32 67,64" style="fill:rgb(0,159,227);" />
                    <polygon points="110,53 110,118 55,86" style="fill:rgb(0,115,189);" />
                    <polygon points="55,86 110,118 55,150" style="fill:rgb(0,86,155);" />
                    <polygon points="55,86 55,150 0,118" style="fill:rgb(21,52,121);" />
                    <polygon points="55,86 0,53 0,118" style="fill:rgb(102,36,131);" />
                    <polygon points="55,86 0,53 55,22" style="fill:rgb(156,115,176);" />
                </svg>
            </router-link>
            <div id="mainTitleSub">
                <router-link to="/">
                    <h1>SAVOIR <br/>ÊTRE AIDANT</h1>
                    <h2>La formation dédiée aux aidants</h2>
                </router-link>
            </div>

        </div>
        <div id="actionMenu">
            <div class="actionMenu-background">
                <svg width="313" height="301">
                    <a v-show="!getUser" href="register">
                        <polygon points="313,60 101,180 313,300" style="fill:rgb(102,36,131);"/>
                        <polygon id="actionButton-background" points="0,126 105,180 0,233" style="fill:rgb(0,159,227);"/>
                    </a>
                    <a v-show="getUser" href="formation">
                        <polygon points="313,60 101,180 313,300" style="fill:rgb(102,36,131);"/>
                        <polygon points="313,60 101,180 313,300" style="fill:rgb(102,36,131);"/>
                        <polygon id="actionButton-background" points="0,126 105,180 0,233" style="fill:rgb(0,159,227);"/>
                    </a>
                    <!--TOUWETER-->
                    <g class="socialItem">
                        <a href="https://twitter.com/@savoiretraidant" target="_blank" alt="Twetter">
                            <polygon points="313,60 262,89 262,30" style="fill:rgb(85,172,238);"/>
                            <g transform="translate(208,-12)">
                                <path id="path3611" transform="scale(0.104)" fill="#FFFFFF" d="m 633.89823,812.04479 c 112.46038,0 173.95627,-93.16765 173.95627,-173.95625 0,-2.64628 -0.0539,-5.28062 -0.1726,-7.90305 11.93799,-8.63016 22.31446,-19.39999 30.49762,-31.65984 -10.95459,4.86937 -22.74358,8.14741 -35.11071,9.62551 12.62341,-7.56929 22.31446,-19.54304 26.88583,-33.81739 -11.81284,7.00307 -24.89517,12.09297 -38.82383,14.84055 -11.15723,-11.88436 -27.04079,-19.31655 -44.62892,-19.31655 -33.76374,0 -61.14426,27.38052 -61.14426,61.13233 0,4.79784 0.5364,9.46458 1.58538,13.94057 -50.81546,-2.55686 -95.87353,-26.88582 -126.02546,-63.87991 -5.25082,9.03545 -8.27852,19.53111 -8.27852,30.73006 0,21.21186 10.79366,39.93837 27.20766,50.89296 -10.03077,-0.30992 -19.45363,-3.06348 -27.69044,-7.64676 -0.009,0.25652 -0.009,0.50661 -0.009,0.78077 0,29.60957 21.07478,54.3319 49.0513,59.93435 -5.13757,1.40062 -10.54335,2.15158 -16.12196,2.15158 -3.93364,0 -7.76596,-0.38716 -11.49099,-1.1026 7.78383,24.2932 30.35457,41.97073 57.11525,42.46543 -20.92578,16.40207 -47.28712,26.17062 -75.93712,26.17062 -4.92898,0 -9.79834,-0.28036 -14.58427,-0.84634 27.05868,17.34379 59.18936,27.46396 93.72193,27.46396"></path>
                            </g>
                        </a>
                    </g>
                    <!-- FACEBOUK-->
                    <g class="socialItem">
                        <a href="https://www.facebook.com/profile.php?id=100016209245159&amp;fref=ts" target="_blank" alt="Facebook">
                            <polygon points="313,60 313,0 262,30" style="fill:rgb(59,89,152);"/>
                            <g transform="translate(273,4)">
                                <path transform="scale(0.158)" id="f" fill="#FFFFFF" d="M182.409,262.307v-99.803h33.499l5.016-38.895h-38.515V98.777c0-11.261,3.127-18.935,19.275-18.935 l20.596-0.009V45.045c-3.562-0.474-15.788-1.533-30.012-1.533c-29.695,0-50.025,18.126-50.025,51.413v28.684h-33.585v38.895h33.585 v99.803H182.409z"></path>
                            </g>
                        </a>
                    </g>
                </svg>
            </div>
            <div v-show="!getUser" class="actionMenu-content">
                <router-link to="/register">
                    Inscrivez-vous pour commencer votre formation.
                </router-link>
            </div>
            <div v-show="getUser" class="actionMenu-content">
                <router-link to="/formation">
                    Suivre votre formation ici
                </router-link>
            </div>
        </div>
        <!--ascenseur vers le haut-->
        <div v-if="scrolled" class="floating-backup">
            <a v-scroll-to="'#app'"><img src= "/static/img/title-4-up.png"/></a>
        </div>
    </header>
</template>
<script>
    import Login from '@/components/Login'
    import AuthenticationService from '../services/authentication.js'
    import { store } from '../services/store'
    import { mapGetters } from 'vuex'
    export default {
        name: 'header',
        store,
        components: {
            'app-login': Login,
        },
        data () {
            return {
                connected : false,
                scrolled: false,
                user: null,
                token: null,
            };
        },

        methods: {
            handleScroll () {
                this.scrolled = window.scrollY > 200;
            },
            setLoggedUser: function () {
                AuthenticationService.getUserByToken({
                    token: this.token
                }).then((res) => {
                    this.user = res.body[0];
                }, (res) => {
                    console.log(res);
                });
                return this.user
            },
        },

        created () {
            window.addEventListener('scroll', this.handleScroll);
            // if(localStorage.getItem("access_token")) {
            //     this.token = localStorage.getItem("access_token");
            //     this.setLoggedUser();
            // }
            this.user = this.$store.state.user;
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        computed: {
            ...mapGetters(['getUser','loggedIn',])
        },
    }
</script>

<style>
    @media (max-width: 850px) {
        #topMenuBar{
            margin-left: -20px;
            font-size: 15px;
        }
        .textSection p {
            color: red;
        }
        #actionMenu{
            /*display: none;*/
        }
    }
    header {
        display: flex;
        flex-direction: column;
    }

    header h1 {
        background: none;
        padding: 0;
        vertical-align: top;
        min-height: 0;
        height: auto;
    }

    header h2 {
        background: none;
        padding: 0;
    }

    .topMenu {
        position: relative;
        top: 0;
        left: 0;
    }

    /*Title and logo*/

    #mainTitle {
        margin: auto;
        color: #0f3274;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 40px;
        position: relative;
        z-index: 1;
    }

    #mainTitle a {
        color: #0f3274;;
        text-decoration: none;
    }

    #mainTitle a:visited {
        color: #0f3274;
        text-decoration: none;
    }

    #mainTitle #mainTitleSub {
        padding-top: 43px;
    }

    #mainTitle img {
        display: block;
    }

    #mainTitle h1 {
        font-family: 'quicksandbold', Arial, serif;
        font-weight: bold;
        font-size: 2.1em;
        margin: 0;
    }

    #mainTitle h2 {
        font-family: 'andes_blackblack', Arial, serif;
        font-size: 1em;
        margin: 0;
    }
    /*nav menu above*/

    #topMenuBar {
        position: absolute;
        top: 5px;
        left: 420px;
        z-index: 10;
        display: block;
    }

    #topMenuBar ul {
        display: flex;
        max-width: 700px;
    }

    #topMenuBar a {
        text-decoration: none;
        color: black;
    }

    #topMenuBar li:hover {
        border-bottom: 3px solid black;
        /* background: url("../img/underline.png") bottom left repeat-x;*/
    }

    #topMenuBar a:visited {
        color: black;
    }

    #topMenuBar li {
        font-size: 1.1em;
        margin-right: 20px;
        border-bottom: none;
        transition-property: all;
        /* Active la transition */
        transition-duration: 200ms;
    }


    /*action menu*/
    #actionMenu {
        position: absolute;
        top: 60px;
        right: 0;
        z-index: 0;
        color: white;
        display: block;

    }

    .actionMenu-background
    {
        position: absolute;
        top: -60px;
        right: 0;
        z-index: -3;
    }

    .actionMenu-content
    {
        position: absolute;
        top: 90px;
        right:0;
        width: 130px;
        vertical-align: bottom;
        z-index:10;
    }
    .actionMenu-content a {
        text-decoration: underline;
        color: white;
    }

    .socialItem
    {
        transition: 0.5s;
    }
    .socialItem:hover
    {
        -webkit-transform:  scale(1.1) translate(-29px,-6px) ;
        transform:  scale(1.1) translate(-28px,-5.5px) ;
        cursor: pointer;
        transition: 0.5s;

    }
    #rs-twitter
    {
        position: absolute;
        top: 10px;
        right:-20px;
        width: 150px;
        opacity: 0.5;
    }
    #rs-twitter:hover
    {
        position: absolute;
        top: 10px;
        right:-20px;
        width: 150px;
        opacity: 1;
    }
    #rs-facebook
    {
        position: absolute;
        top: 10px;
        right:-60px;
        width: 150px;
        opacity: 0.5;
    }
    #rs-facebook:hover
    {
        position: absolute;
        top: 10px;
        right:-60px;
        width: 150px;
        opacity: 1;
    }
    #actionButton-background
    {
        animation: pulse 2s linear alternate infinite;
        transition-property: all;
        transition-duration: 200ms;
        cursor: pointer;
        transform-origin:left 50%;
    }
    #actionButton-background a:hover
    {
        animation: slide 2s linear alternate;
        /*USE ANOTHER KEYGRAMES ANIMATION*/
    }

    @keyframes pulse {
        from {
            transform: scale(1, 1);
            fill: #0073bc;
        }

        50% {
            transform: scale(1.1, 1.1);
            fill: #30a3ec;
        }

        to {
            transform: scale(1, 1);
            fill: #0073bc;
        }
    }
    @keyframes slide {
        from {
            transform: translate(0,0);
        }

        50% {
            transform: translate(20,0);
        }

        to {
            transform: translate(0,0);
        }
    }
    .floating-backup
    {
        position:fixed;
        top:45px;
        right:8px;
        z-index:800;
    }
    .floating-backup a:hover:before
    {
        content: "Remonter";
        position: absolute;
        bottom:-15px;
        right:0px;
        width:60px;
        font-size:0.8em;
        z-index:10;
        text-shadow: 2px 2px 8px black;
    }
</style>



// WEBPACK FOOTER //
// Header.vue?0507cb76